<form (ngSubmit)="onSubmit()" [formGroup]="formCategory">
  <p-dialog header="{{ title }}" [modal]="true" [(visible)]="visible" [style]="{ width: '25vw' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" (onHide)="closeDialog()">
    <div class="flex align-items-center gap-2 mb-4">
      <i class="pi pi-tag text-primary text-2xl"></i>
      <span class="text-secondary">{{ subtitle }}</span>
    </div>

    <div class="field">
      <app-input label="Nombre*" [formControl]="formUtilities.getControl(formCategory, 'name')" name="name"
        type="text-required" [customErrorMessages]="{
          required: 'Este campo es requerido',
          minlength: 'El nombre debe tener al menos 3 caracteres'
        }" />
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <p-button label="Cancelar" severity="secondary" icon="pi pi-times" (onClick)="closeDialog()"
          [outlined]="true" />
        <p-button label="Aceptar" type="submit" icon="pi pi-check" [disabled]="formCategory.invalid" />
      </div>
    </ng-template>
  </p-dialog>
</form>